import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const assetUrl = (p) => (p && p.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${p}` : p);

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("np_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use((r) => r, (e) => {
  const d = e?.response?.data?.detail;
  if (e?.response?.status === 401 && typeof d === "string" && d.startsWith("Logged in on another device")) {
    localStorage.removeItem("np_token");
    sessionStorage.setItem("np_logout_reason", "Your account was logged in on another device, so you were logged out here.");
    if (window.location.pathname.startsWith("/app")) window.location.assign("/app");
    else if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/secure")) window.location.assign((window.location.pathname.startsWith("/admin") && localStorage.getItem("np_admin_path")) || "/login");
  }
  return Promise.reject(e);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const inr = (v) =>
  "₹" + Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "-");

export const today = () => new Date().toISOString().slice(0, 10);
export const daysAgo = (n) => new Date(Date.now() - n * 864e5).toISOString().slice(0, 10);

export function exportCsv(name, rows, cols) {
  const head = cols.map((c) => c.label).join(",");
  const body = rows.map((r) => cols.map((c) => `"${String(c.csv ? c.csv(r) : r[c.key] ?? "").replace(/"/g, "'")}"`).join(",")).join("\n");
  const blob = new Blob([head + "\n" + body], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${name}.csv`;
  a.click();
}
